import { reactive, readonly } from 'vue';
import router from '@/router';

// Shared booking state. The booking flow lives on its own page (/plan, see
// PlanView.vue); any component can start it — optionally pre-selecting a
// package — via openBooking(pkg?), which stores the package and navigates there.
const state = reactive({
  pkg: null, // pre-selected package, or null
});

function openBooking(pkg = null) {
  state.pkg = pkg || null;
  router.push({ name: 'plan' });
}

function resetBooking() {
  state.pkg = null;
}

export function useBooking() {
  return { booking: readonly(state), openBooking, resetBooking };
}
